import { commonErrorMessages } from '../../../../messages';
import { ErrorMessages } from '../../../../model/error';
import { FileDownloadedError } from './common-types';

export const messagesForDownloadDocumentsFileError = (
  error: FileDownloadedError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};
